var React = require('react');

function FranceInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Group-4"},[React.createElement("polygon",{"id":"Fill-1","fill":"#2B388F","points":"0 42.3529 21.177 42.3529 21.177 -0.0001 0 -0.0001","key":0}),React.createElement("polygon",{"id":"Fill-2","fill":"#FEFEFE","points":"21.177 42.3529 42.353 42.3529 42.353 -0.0001 21.177 -0.0001","key":1}),React.createElement("polygon",{"id":"Fill-3","fill":"#BE1E2D","points":"42.353 42.3529 63.529 42.3529 63.529 -0.0001 42.353 -0.0001","key":2})])));
}

FranceInline.defaultProps = {"width":"64px","height":"43px","viewBox":"0 0 64 43","version":"1.1"};

module.exports = FranceInline;

FranceInline.default = FranceInline;
